module.exports = __webpack_public_path__ + "static/testimonial-1-a155fc629d367fb0ee95ee8a7b2cba88.mp4";